import React from 'react';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface CountryFormProps {
  mode: FormMode;
}

export default function CountryForm({ mode }: CountryFormProps) {
  const isDisabled = mode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
      <div className='p-4 md:p-6'>
        <div className='flex flex-col gap-y-4 md:gap-y-6'>
          <div className='space-y-4 md:space-y-6'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã quốc gia</Label>
              <FormField type='text' name='ma_qg' disabled={isDisabled} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên quốc gia</Label>
              <FormField type='text' name='ten_qg' disabled={isDisabled} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
              <FormField type='text' name='ten_qg2' disabled={isDisabled} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label htmlFor='trang_thai' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
                Trạng thái
              </Label>
              <FormField
                id='trang_thai'
                type='select'
                name='status'
                defaultValue={1}
                disabled={isDisabled}
                options={[
                  { label: '1. Còn sử dụng', value: 1 },
                  { label: '2. Không sử dụng', value: 2 }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
